import { Notice } from './Notice';

export interface NoticeReceiver extends Notice {
  receiverkey: number;
  read: boolean;
  hidden: boolean;
  received: Date;
  templatekey?: NoticeTemplatekey;
  assets?: NotificationAsset;
}

export interface NotificationAsset {
  coursekey: number;
  courseversion: number;
  groupkey: number;
  layer: number;
  memberkey: number;
  modulekey: number;
  userkey: number;
}

/** PublicAPI
 * NoticeTemplatekeys.
 */
export const NoticeTemplateIds = [
  'CourseVersionPublish', //Updated content is available
  'GroupMemberAdd', //Content access updated
  'GroupCourseAdd', //New content is available
  'UserPortfolioLock', //Assessment finalised
  'UserPortfolioRetry', //Assessment requires attention
  'UserPortfolioResubmit', //Assessment resubmitted
  'UserPortfolioSubmit' // To Assessors. A portfolio attempt has been submitted to the assessor pool.
];

export type NoticeTemplatekey = (typeof NoticeTemplateIds)[number];
